import qsObj from '@/utils/qs';
import envConfig from '../config/env-config';
window['$envConfig'] = envConfig;
import foodConfig from './food-config';
window['$foodConfig'] = foodConfig;

import Vue from 'vue';
import { getValue } from '@/utils/util';
import debounce from 'lodash.debounce';
import asyncEraser from '@/utils/async-eraser';

import EventBus from './utils/eventBus.js';
const $bus = new EventBus(); // 事件总线 new Vue()

const $sleep = (t = 0) => new Promise(r => setTimeout(r, t, '$sleep:' + t));
const $log = o => console.log(JSON.parse(JSON.stringify(o)));
const $pure = o => JSON.parse(JSON.stringify(o));
const $autoOn = function (eventName, listener) {
    // TODO call this
    this.$bus.$on(eventName, listener);
    this.$on('hook:beforeDestroy', () => {
        this.$bus.$off(eventName, listener);
    });
};
// 在vue组件卸载的时候会自动卸载监听的原生事件
const $autoOnNative = function (target, eventName, listener, capture = false) {
    target.addEventListener(eventName, listener, capture);
    this.$on('hook:beforeDestroy', () => {
        target.removeEventListener(eventName, listener);
    });
};

// 当原生事件发生后立刻解绑事件 主要是为了动画用的
const $onNativeOnce = async function (_el, event = 'transitionend', timeout = 5000) {
    await $sleep(0); // 某些情况下 直接来会出问题
    let el = typeof _el === 'string' ? this.$gp(_el) : _el;
    return new Promise(async (resolve) => {
        if (!el) {
            console.error('eventTrigger:el不存在', _el, el);
            // debugger
            await this.$sleep(100);
            resolve();
            return void 0;
        }
        let timer = null;
        let cb = async () => {
            el.removeEventListener(event, cb);
            await this.$sleep(0); // 某些情况下需要出发事件轮询 解决Listener移除不及时问题
            clearTimeout(timer);
            resolve(_el + ':end');
        };
        el.addEventListener(event, cb);
        timer = setTimeout(async () => {
            el.removeEventListener(event, cb);
            console.error('eventTrigger:超时', _el, el);
            // debugger
            await this.$sleep(0);
            resolve(_el + ':timeout');
        }, timeout);
    });
};

Object.defineProperties(Vue.prototype, { $bus: { get: function () {return $bus;} } });
Vue.prototype.$sleep = $sleep;
Vue.prototype.$log = $log;
Vue.prototype.$pure = $pure;
Vue.prototype.$autoOn = $autoOn;
Vue.prototype.$autoEmit = $bus.$emit; // 暂时不启动 语义上emit没有auto的情况
Vue.prototype.$autoOnNative = $autoOnNative;
Vue.prototype.$g = getValue;
Vue.prototype.$onNativeOnce = $onNativeOnce;
Vue.prototype.$ae = asyncEraser;
Vue.prototype.$asyncEraser = asyncEraser;

window['$bus'] = $bus;
window['$sleep'] = $sleep;
window['$l'] = $log;
window['$f'] = $pure;
window['$onNativeOnce'] = $onNativeOnce;
window['$ae'] = asyncEraser;
window['$asyncEraser'] = asyncEraser;

window['autoAnimation'] = true;
if (qsObj.auto === 'false') {
    console.log('手动设置：autoAnimation' + window['autoAnimation']);
    window['autoAnimation'] = false;
}

const $getParam = function (str, ctx) {
    let _self = ctx || this;
    let getFun = function (str) {
        let value = eval(str);
        if (!value) {
            console.error(str, 'is null');
        }
        return value;
    };
    return getFun.call(_self, str);
};
window['$gpara'] = $getParam;
window['$gp'] = $getParam;
Vue.prototype.$gpara = $getParam;
Vue.prototype.$gp = $getParam;

window.addEventListener('resize', debounce(() => {
    $bus.$emit('window-resize');
}, 500), false);

// 自动停止
let isRunning = true;
let runnerTimer = null;
let runingTo2dTimer = null;
// let runWaitTime = 1000 * 1000;
let runWaitTime = $qsObj.waittime || 600 * 1000;
function clickEvent(e) {
    if (window['_screenType'] === '2160') {
        runWaitTime = $qsObj.waittime || 60000 * 1000;
    }
    if (window['runingTo2d'] === true) {
        if (runingTo2dTimer) {
            clearTimeout(runingTo2dTimer);
            runingTo2dTimer = null;
            return;
        }
        runingTo2dTimer = setTimeout(() => {
            isRunning = true;
            window['runingTo2d'] = false;
        }, 3000);
    }
    clearTimeout(runnerTimer);
    runnerTimer = setTimeout(() => {
        isRunning = true;
        if (qsObj.auto === 'false') return void 0;
        window['autoAnimation'] = true; // TODO 好好测试自动脚本再动起来的样子
        $bus.$emit('action-script-start');
    }, runWaitTime);

    // if (isRunning === true) {
        // isRunning = false;
        // e.stopPropagation();
        // e.preventDefault();
    $bus.$emit('action-script-stop');
    // }
    $bus.$emit('action-script-stop-common');
}
window.addEventListener('dblclick', clickEvent, true); // window的useCapture必须为true， 因为图谱上发生的点击，不冒泡);
window.addEventListener('click', clickEvent, true); // window的useCapture必须为true， 因为图谱上发生的点击，不冒泡);

$bus.$on('action-script-run', () => {
    isRunning = true;
    clearTimeout(runnerTimer);
});

// 帧率测试 开发环境才会启用这个
import Stats from './utils/stats.js';
let statsFlag = false;
if (process.env.NODE_ENV === 'development' && statsFlag) {
    let stats = new Stats();
    stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
    document.body.appendChild(stats.dom);

    let animate = () => {
        stats.begin();
        // monitored code goes here
        stats.end();
        requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
}

window['$$$sleep'] = (t) => {
    let startTime = Date.now();
    console.log('$$$sleep startTime', startTime);
    let walkFlag = true;
    while (walkFlag) {
        let endTime = Date.now();
        if (endTime - startTime >= t) {
            console.log('$$$sleep endTime', endTime, endTime - startTime);
            walkFlag = false;
        }
    }
};

if (!window['G2']) {
    window['G2'] = {};
}

Vue.filter('brainPrice', function (price) {
    if ($foodConfig.$lang === 'en') {
        let exchangeRate = 6.87;
        let _usd: any = price / exchangeRate;
        let cnt = 0;
        if (_usd < 11) {
            cnt = 1;
        }
        if (_usd >= 11 && _usd < 31) {
            cnt = 2;
        }
        if (_usd >= 31 && _usd <= 61) {
            cnt = 3;
        }
        if (_usd >= 61) {
            cnt = 3;
        }
        return '$'.repeat(cnt);
    } else if ($foodConfig.$lang === 'zh') {
        return '￥' + price;
    } else {
        return price;
    }
});


Vue.prototype.$filterImgSrc = function(value) {
    let baseUrl = window['_baseImgUrl'] || '/blue';
    return require('../static/img/2d' + baseUrl + value);
};
